export default [
  {
    path: '/page',
    component: () => import('@/components'),
    // children: [
    //   {
    //     path: 'applicationManagement',
    //     name: 'ApplicationManagement',
    //     component: () => import('@/pages/ApplicationManagement')
    //   },
    //   {
    //     path: 'applicationManagementList',
    //     name: 'ApplicationManagementList',
    //     component: () => import('@/pages/ApplicationManagement/list'),
    //     meta: { name: '库存配置' }
    //   },
    //   // {
    //   //   path: 'applicationManagementDetail',
    //   //   name: 'ApplicationManagementDetail',
    //   //   component: () => import('@/pages/ApplicationManagement/detail'),
    //   //   meta: { name: ['应用管理', '应用详情'] }

    //   // },
    //   {
    //     path: 'trigger',
    //     name: 'Trigger',
    //     component: () => import('@/pages/trigger'),
    //     meta: { name: '时间段设置' }
    //   },
    //   {
    //     path: 'globalVariable',
    //     name: 'GlobalVariable',
    //     component: () => import('@/pages/globalVariable'),
    //     meta: { name: '自动接单设置' }
    //   },
    //   // {
    //   //   path: 'apiCenter',
    //   //   name: 'ApiCenter',
    //   //   component: () => import('@/pages/apiCenter'),
    //   //   meta: { name: 'API中心' }
    //   // },
    //   // {
    //   //   path: 'apiCenterDetail',
    //   //   name: 'ApiCenterDetail',
    //   //   component: () => import('@/pages/apiCenter/detail'),
    //   //   meta: { name: ['API中心', '公开项目详情'] }
    //   // },
    //   // {
    //   //   path: 'taskManage',
    //   //   name: 'TaskManage',
    //   //   component: () => import('@/pages/taskManage'),
    //   //   meta: { name: '任务管理' }
    //   // },
    //   // {
    //   //   path: 'taskManageDetail',
    //   //   name: 'TaskManageDetail',
    //   //   component: () => import('@/pages/taskManage/detail'),
    //   //   meta: { name: ['任务管理', '任务详情'] }
    //   // },
    //   // {
    //   //   path: 'createPlannerPro',
    //   //   name: 'CreatePlannerPro',
    //   //   component: () => import('@/pages/taskManage/detail/createPlannerPro'),
    //   //   meta: { name: '任务编排' }
    //   // },
    // ]
  },
]



// WEBPACK FOOTER //
// ./src/router/applicationManagement/index.js